import React from "react";

import Layout from "./component/Layout";
import Main from "./view/main";

function App() {
  return (
    <Layout>
      <Main />
    </Layout>
  );
}

export default App;
